import { Forwarding } from '../types'

export type ForwardingWithClientId = Forwarding & {
  _clientId?: string
}

export const isSameForwarding = (
  item: ForwardingWithClientId,
  target: ForwardingWithClientId,
): boolean => {
  if (target.guid && item.guid) {
    return item.guid === target.guid
  }

  if (target._clientId && item._clientId) {
    return item._clientId === target._clientId
  }

  return item === target
}
